<template>
  <UiModal
    :value="value"
    :destroy="true"
    :show-footer="false"
    window-class="questionnaire-modal"
    @input="$emit('input', $event)"
  >
    <div class="questionnaire-question questionnaire-content">
      <div class="questionnaire__header -full-">
        <div v-if="!loadingFaculty" class="questionnaire__title -margin-m-">
          Ты можешь изменить {{ typeName }}
        </div>
        <div
          v-else
          class="questionnaire__title -margin-m- ajax__line -round-"
          :style="{ width: 'calc(100% - 40px)', height: 'calc(1em + 2px)' }"
        ></div>
        <div v-if="!loadingFaculty" class="questionnaire__description">
          Ты можешь выбрать {{ typeName }} из доступных для ученика
        </div>
        <div
          v-else
          class="questionnaire__description -margin-m- ajax__line -round-"
          :style="{ width: 'calc(100% - 60px)', height: 'calc(1em + 2px)' }"
        ></div>
      </div>
      <div class="questionnaire-question-grid -one- questionnaire__limiter -center- -margin-m-">
        <Select
          :options="facultyList"
          :value="faculty"
          option-text="title"
          option-key="value"
          :label="`${type === 'group' ? 'Сборная' : type === 'faculty' ? 'Факультет' : ' '}`"
          :placeholder="`Выбери ${typeName || ' '}`"
          opacity
          @change="faculty = $event"
        />
        <Icon class="questionnaire-modal-content__img" icon="ui-computer-learn"></Icon>
      </div>
      <UiButton :disabled="!faculty.value" @click="showConfirmModal">Сохранить</UiButton>
    </div>
    <UiModal
      v-model="isConfirmModalOpen"
      :body-class="!changed && '-left-'"
      accept-text="Подтвердить"
      reject-text="Закрыть"
      accept-color="primary"
      reject-color="blue-gray"
      accept-class="-smart- questionnaire-modal__button -min-"
      reject-class="-smart- questionnaire-modal__button -min-"
      :destroy="true"
      :show-footer="!changed"
      :reverse="true"
      :loading-accept="sending"
      @accept="send"
      @reject="unshowConfirmModal"
    >
      <template v-if="!changed">
        <div class="ui-kit-modal__title">
          Ты действительно хочешь изменить {{ typeName }} участника?
        </div>
        <p>
          Если ты сменишь {{ typeName }}, участник больше не сможет просматривать
          {{ type === 'group' ? 'предыдущую сборную' : 'предыдущий факультет' }}.
        </p>
      </template>
      <template v-else>
        <div class="questionnaire-modal-content -center-">
          <div class="ui-kit-modal__title">Ты успешно изменил {{ typeName }}!</div>
          <Icon class="questionnaire-modal-content__img" icon="ui-computer-learn"></Icon>
          <UiButton class="questionnaire-modal-content__button" @click="unshowConfirmModal">
            Сохранить
          </UiButton>
        </div>
      </template>
    </UiModal>
  </UiModal>
</template>

<script>
import Select from '@/components/UiKit/v2/Select/index.vue';

export default {
  components: {
    Select
  },
  props: {
    value: {},
    userId: {}
  },
  data: () => ({
    recomendedCourse: 'speed',
    selectedCourse: null,
    isConfirmModalOpen: false,
    sending: false,
    changed: false,
    facultyList: [],
    faculty: {},
    type: null,
    loadingFaculty: false
  }),
  computed: {
    typeName() {
      switch (this.type) {
        case 'group':
          return 'сборную';
        case 'faculty':
          return 'факультет';
        default:
          return undefined;
      }
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.getUserFaculty();
      }
    },
    isConfirmModalOpen(state) {
      if (!state && this.changed) {
        this.clearSuccessData();
        // Сейчас модалка связанна со строкой таблицы
        // 'updateCourse' вызовет удаление строки и модалка исчезнет
        // Так что вызываем обновление только после закрытия
        this.$emit('updateUser');
      }
    }
  },
  methods: {
    async getUserFaculty() {
      this.loadingFaculty = true;
      const res = await this.$store.dispatch('questionnaire/getUserFaculty', {
        user: this.userId
      });
      if (res.status === 'success') {
        this.facultyList = res.data.faculties.map(({ id, name }) => ({
          value: id,
          title: name
        }));
        this.type = res.data.type;
      }
      this.loadingFaculty = false;
    },
    async send() {
      this.sending = true;
      const res = await this.$store.dispatch('questionnaire/setFaculty', {
        faculty: this.faculty.value,
        userId: this.userId
      });
      this.sending = false;

      if (res.status === 'success') {
        this.changed = true;
      }
    },
    showConfirmModal() {
      this.isConfirmModalOpen = true;
    },
    unshowConfirmModal() {
      this.isConfirmModalOpen = false;
    },
    clearSuccessData() {
      this.unshowConfirmModal();
      this.$emit('input', false);
      this.changed = false;
      this.selectedCourse = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.questionnaire__header {
  margin-bottom: 0;
}

.questionnaire-question-grid {
  .opacity.selector {
    width: 100%;
  }
}
</style>
